export const getFreeTierLogicalSizes = {
  nodes: (50000).toLocaleString(),
  relationships: (175000).toLocaleString(),
};
